// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__HkT2y","overflowing":"ReadFullNote_overflowing__1noXU"};